<template>
    <div class="config-list">
        <div class="config-list-item" v-for="item in list" :key="item.app_id + item.package_name">
            <FormItem ref="formItemRef" :key="item.app_id + item.package_name" :default-data="item" :deeplinkValidConfig="deeplinkValidConfig"/>
        </div>
    </div>
</template>

<script>
import FormItem from './formItem.vue'
export default {
    name: 'LinkConfig',
    props: [ 'list', 'deeplinkValidConfig' ],
    components: {
        FormItem
    },
    methods: {
        validate() {
            return Promise.all(this.$refs.formItemRef.map(item => item.validateFn()))
        }
    }
}
</script>

<style lang="scss" scoped>
.config-list {
    margin-right: 20px;
    max-width: 600px;
    &-item {
        margin-bottom: 12px;
    }
}
</style>